<template>
  <v-dialog
    id="onboarding-container"
    class="border-radius-15"
    origin="center center"
    v-model="open"
    persistent
    attach="#root"
    content-class="onboarding-dialog-active"
    hide-overlay
  >
    <!-- <v-toolbar flat color="#D6B682">
      <v-toolbar-title class="bebas black--text">troubleshooting</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn color="black" flat left>close<v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>-->
    <v-card max-height="100%" color="black white--text" class="pa-3">
      <v-card-title class="display-1 bebas justify-center">Welcome Detectives</v-card-title>
      <v-divider dark></v-divider>
      <v-container class="prestige instructions-container">
        <v-layout row wrap>
          <v-flex
            xs12
          >Before logging in, please follow the instructions below to download this application to your Home Screen (It works best that way).</v-flex>
          <v-flex v-if="onIphone" xs12 mt-3 id="android-aths-instructions">
            <ol>
              <li>
                Click the Share Button on the bottom of your screen
                <v-flex d-flex text-xs-center>
                  <v-flex>
                    <v-img :src="shareButtonFull" />
                  </v-flex>
                </v-flex>
              </li>
              <li>
                Click the Add To Home Screen Option
                <v-flex d-flex text-xs-center>
                  <v-flex>
                    <v-img :src="shareMenuFull" />
                  </v-flex>
                </v-flex>
              </li>
              <li>
                Click the Add Button
                <v-flex d-flex text-xs-center>
                  <v-flex>
                    <v-img :src="athsFull" />
                  </v-flex>
                </v-flex>
              </li>
              <li>
                Use the Icon from this point on to open the Application
                <v-flex d-flex text-xs-center>
                  <v-flex>
                    <v-img :src="iconView" />
                  </v-flex>
                </v-flex>
              </li>
            </ol>
          </v-flex>
          <v-container v-else>
            <v-flex
              d-flex
              text-xs-center
            >Click Add to get prompted to add this Application to your home screen.</v-flex>
            <v-flex xs12 d-flex>
              <v-btn large color="#AE250A" @click.native="athsAction">
                Add
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-container>
          <v-flex class="bebas" light d-flex text-xs-center justify-center align-center mt-2>
            <v-flex xs12>
              <v-btn
                block
                large
                class="border-radius-5"
                color="white black--text"
                @click="onboardingFinished"
              >finish setup</v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import athsFull from "@/assets/onboarding/add-min.png";
import shareButtonFull from "@/assets/onboarding/share-min.png";
import shareMenuFull from "@/assets/onboarding/home-min.png";
import iconView from "@/assets/onboarding/homescreen-min.png";

export default {
  name: "onboarding-container",
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      onboardingStep: 2,
      athsFull,
      shareMenuFull,
      shareButtonFull,
      iconView,
      e6: 1,
      e7: 1,
      maxOnboardingStep: 1
    };
  },
  watch: {
    preloadingImages: function(newData, oldData) {
      if (!newData && this.setupFinished) {
        this.onboardingStep = 2;
      }
    },
    setupFinished: function(newData, oldData) {
      if (newData && !this.preloadingImages) {
        this.onboardingStep = 2;
      }
    }
  },
  mounted() {
    //this.athsSetup()
  },
  computed: {
    serviceWorkerActivated() {
      return this.$store.getters.serviceWorkerActivated;
    },
    serviceWorkerAvailable() {
      return this.$store.getters.serviceWorkerAvailable;
    },
    preloadingImages(val) {
      return this.$store.getters.preloadingImages;
    },
    onIphone() {
      return this.$store.getters.isIos;
    },
    setupFinished() {
      return this.$store.getters.setupFinished;
    }
  },
  methods: {
    athsSetup() {
      //console.log("Setting up");
      window.addEventListener("beforeinstallprompt", e => {
        //console.log("BEFORE INSTALL PROMPT");
        e.preventDefault();
        this.deferredPrompt = e;
      });
    },
    onboardingFinished() {
      this.$store.dispatch("setOnboarding", false);
      this.onboardingStep = 4;
      this.$store.dispatch("setDemoRequest", true);
      // window.close();
    },
    athsAction() {
      const prompt = this.$store.getters.deferredPrompt;
      //console.log("IN ATHS", prompt);
      if (prompt) {
        prompt.prompt();
        prompt.userChoice.then(choiceResult => {
          if (choiceResult.outcome === "accepted") {
            //console.log("User accepted the A2HS prompt");
          } else {
            //console.log("User dismissed the A2HS prompt");
          }
        });
        this.onboardingStep = 3;
      } else {
        this.onboardingStep = 3;
      }
    },
    startInstructionsOver() {
      this.onboardingStep = 2;
      this.e6 = 1;
      this.e7 = 1;
    },
    finalATHS() {
      this.e6 = 1;
    }
  }
};
</script>

<style scoped>
#onboarding-dialog-active {
  height: 500px;
}

#android-aths-instructions ol > li {
  margin: 20px 0px;
}

.instructions-container {
  font-size: 18px;
}
</style>

    <!-- <v-stepper-step color="red" class="white--text" :complete="onboardingStep > 1" step="1">
      Downloading Murder Mystery Tour from FDI Headquarters
      <small v-if="onboardingStep === 1">Please wait</small>
    </v-stepper-step>

    <v-stepper-content step="1">

      <v-progress-linear color="red" :indeterminate="true"></v-progress-linear>

    </v-stepper-content> -->
